import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import review from './modules/review';
import plans from './modules/payment_plans';
import dashboardStats from './modules/dashboard_stats';
import studyPlans from './modules/study_plans';
import milestones from './modules/milestones';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {user, review, plans, dashboardStats, studyPlans, milestones},
    state: {}
});
